import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import ParticipanteSidebar from '../components/ParticipanteSidebar';

export default function ParticipanteDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function sair() {
    await logout();
    window.location.href = '/login';
  }

  return (
    <>
      <ParticipanteSidebar />

      <main
        style={{
          minHeight: '100vh',
          background: '#f4f4f4',
          padding: '2.5rem 1.5rem',
          boxSizing: 'border-box',
          marginLeft: 220
        }}
      >
        <div
          style={{
            maxWidth: 1180,
            margin: '0 auto'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 20,
              flexWrap: 'wrap',
              marginBottom: 30
            }}
          >
            <div>
              <h1
                style={{
                  margin: 0,
                  color: '#242F3C',
                  fontSize: '2rem'
                }}
              >
                Meu painel
              </h1>

              <p
                style={{
                  color: '#697382',
                  marginTop: 8,
                  marginBottom: 0
                }}
              >
                Acompanhe suas avaliações e consulte seus resultados ICV.
              </p>

              <div
                style={{
                  marginTop: 8,
                  color: '#98A2B3',
                  fontSize: '0.92rem'
                }}
              >
                {user?.nome || user?.email || 'Participante'}
              </div>
            </div>

            <button
              type="button"
              onClick={sair}
              style={{
                background: '#242F3C',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '10px 18px',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Sair
            </button>
          </div>

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: '1.6rem',
              boxShadow: '0 2px 10px rgba(36,47,60,0.06)'
            }}
          >
            <h2
              style={{
                margin: 0,
                color: '#242F3C',
                fontSize: '1.25rem'
              }}
            >
              Minhas avaliações
            </h2>

            <p
              style={{
                color: '#697382',
                lineHeight: 1.6,
                marginBottom: 20
              }}
            >
              Consulte seu histórico de avaliações ICV e abra os relatórios
              disponíveis.
            </p>

            <button
              type="button"
              onClick={() => navigate('/participante/avaliacoes')}
              style={{
                background: '#F36611',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '11px 18px',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Ver minhas avaliações
            </button>
          </section>
        </div>
      </main>
    </>
  );
}
